/**
 * View for variant chooser.
 *
 * Appears to select a variant, then disappears for the variant options.
 * 
 */

var sw  = require('js/lib/sw');
var $   = require('js/sw-jquery/sw-jquery');
var ShapewaysView = require('./ShapewaysView');

var HIDDEN_CLASS = 'sw--is-hidden';

var VariantDropdownView = ShapewaysView.extend({
  swAttrs: {
    'variantSelector':          'data-sw-variant-select',
    'variantTitle':             'data-sw-variant-dropdown-name',
    'variantSelectorContainer': 'data-sw-dropdown-selector-container',
    'variantTitleContainer':    'data-sw-variant-dropdown-name-container',
    'variantDeselect':          'data-sw-variant-dropdown-remove'
  },

  swSelectors: {
    'variantMinimalectUL': 'div.minict_wrapper ul:eq(0)'
  },

  events: function(){
    var eventHash = {};

    eventHash['change ' + this.swSelectors.variantSelector] = 'variantSelected';
    eventHash['click ' + this.swSelectors.variantDeselect] = 'variantDeselected';

    return eventHash;
  },

  variantSelected: function variantSelected(e) {
    var actionCreators = this.model.getActionCreators();
    var $target = $(e.currentTarget);
    var variantId = $target.val();

    // Don't want to trigger anything when a variant has been deselected, 
    // but need the change event to reset the dropdown and have minimalect respond.
    if (variantId) {
      sw.dispatch(actionCreators.variantSelected(variantId));

      var variants = this.model.get('variants');
      var variantName = variants[variantId].title;

      sw.trigger('sw-toggle-variant-chooser');

      this.cachedElements.$variantTitle.html(variantName);
      this.cachedElements.$variantSelectorContainer.addClass(HIDDEN_CLASS);
      this.cachedElements.$variantTitleContainer.removeClass(HIDDEN_CLASS);

      // To work with vendor code. Sometimes when we hide the div, the minimalect dropdown
      // doesn't get hidden in time, and will show up as open, even though the minimalect
      // dropdown thinks it's actually closed.
      this.cachedElements.$variantMinimalectUL.css({display: 'none'});
    }
  },

  variantDeselected: function variantDeselected() {
    var actionCreators = this.model.getActionCreators();
    this.cachedElements.$variantSelector.val('');
    this.cachedElements.$variantSelector.change();
    sw.dispatch(actionCreators.variantDeselected(this.model.get('chosenVariant')));
    sw.trigger('sw-toggle-variant-chooser');

    this.cachedElements.$variantTitleContainer.addClass(HIDDEN_CLASS);
    this.cachedElements.$variantSelectorContainer.removeClass(HIDDEN_CLASS);
  }

});

module.exports = VariantDropdownView;
